import { inject, Service } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { SentenceCase } from '../../utils/sentence-case';
import { WebConfigService } from '../web-config/web-config.service';

@Service()
export class TitleStrategyService extends TitleStrategy {
  webconfig = inject(WebConfigService);
  private readonly title = inject(Title);

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    const { portalId } = this.webconfig;
    this.title.setTitle(`Halo Dot Go ${SentenceCase.toSentenceCase(portalId)} portal${title ? ' - ' + title : ''}`);
  }
}
